import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_DETALLE_FUERA_DE_GRADO } from '../../../../config/tables'

function DetalleFueraDeGradoView () {
  return (
    <MuiTable id={TABLA_DETALLE_FUERA_DE_GRADO} />
  )
}

export default DetalleFueraDeGradoView
